import { IngestionSubmission } from "./data.ingestion.service";

export function isWorkflowSpawnedDraft(submission: IngestionSubmission): boolean {
    return submission.parentProcessInstanceId != null && !submission.submitted;
}

export function isSelfSavedDraft(submission: IngestionSubmission): boolean {
    return !submission.submitted && submission.parentProcessInstanceId == null;
}

export function submissionMatchesDashboardStatusFilter(submission: IngestionSubmission, status: string): boolean {
    if (status === "DRAFT") {
        return !submission.submitted;
    }
    if (status === "ACTION_NEEDED") {
        return isWorkflowSpawnedDraft(submission);
    }
    if (status === "SAVED_DRAFT") {
        return isSelfSavedDraft(submission);
    }
    if (status === "COMPLETED") {
        return submission.workflowStatus === "COMPLETED";
    }
    if (status === "SUBMITTED") {
        return !!submission.submitted && !submission.workflowStatus;
    }
    return submission.workflowStatus === status;
}
